<template>
    <el-select v-model="selectedMaterial" filterable remote reserve-keyword :placeholder="placeholder"
        :remote-method="remoteMethod" :loading="loading" @change="handleChange">
        <el-option v-for="item in options" :key="item.material_code" :label="item.name" :value="item.material_code">
            <span style="float: left">{{ item.name }}</span>
            <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.material_code }}</span> -->
        </el-option>
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import axios from 'axios';

export interface Material {
    material_code: string;
    name: string;
    organization_id: string;
    category_id: string;
    expiration_day: number;
}

export default defineComponent({
    name: 'MaterialSelect',
    props: {
        organizationId: {
            type: String,
            default: '',
        },
        categoryId: {
            type: String,
            default: '',
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '选择资财',
        },
    },
    emits: ['update:modelValue', 'change', 'material-name-change', 'update:organization-id', 'update:category-id', 'update:expiration-day'],
    setup(props, { emit }) {
        const loading = ref(false);
        const options = ref<Material[]>([]);
        const selectedMaterial = ref(props.modelValue);



        const fetchMaterialById = async (id: string) => {
            try {
                const response = await axios.get(`/api/materials/${id}`);
                if (response.data.data) {
                    options.value = [response.data.data];
                    selectedMaterial.value = response.data.data.material_code;
                    handleChange(response.data.data.material_code);
                }
            } catch (error) {
                console.error('获取资财信息失败:', error);
            }
        };

        const remoteMethod = async (query: string) => {
            if (query !== '') {
                loading.value = true;
                try {
                    const response = await axios.get('/api/materials/name', {
                        params: { name: query, organization_id: props.organizationId, category_id: props.categoryId }
                    });
                    options.value = response.data.data || [];
                } catch (error) {
                    console.error('搜索资财失败:', error);
                    options.value = [];
                } finally {
                    loading.value = false;
                }
            } else {
                options.value = [];
            }
        };

        const handleChange = (value: string) => {
            emit('update:modelValue', value);
            emit('change', value);
            // 找到选中的资财对象
            const selectedMaterialObj = options.value.find(
                mat => mat.material_code === value
            );
            // 如果找到了资财对象，发送名称
            if (selectedMaterialObj) {
                emit('material-name-change', selectedMaterialObj.name);

                // 反向设置 organizationId 和 categoryId
                emit('update:organization-id', selectedMaterialObj.organization_id);
                emit('update:category-id', selectedMaterialObj.category_id);
                emit('update:expiration-day', selectedMaterialObj.expiration_day);
            };
        }


        const emitExpirationDay = (materialCode: string) => {
            const selectedMaterialObj = options.value.find(
                mat => mat.material_code === materialCode
            );
            if (selectedMaterialObj) {
                emit('update:expiration-day', selectedMaterialObj.expiration_day);
            }
        };

        watch(() => props.modelValue, (newValue) => {
            selectedMaterial.value = newValue;
            if (!newValue) {
                return;
            }
            // JAN/扫码回填时，即便 options 里已有该 item，也要再发一次初期期限
            if (options.value.some(mat => mat.material_code === newValue)) {
                emitExpirationDay(newValue);
                return;
            }
            fetchMaterialById(newValue);
        });

        watch(() => props.organizationId, (newOrgId, oldOrgId) => {
            if (newOrgId === oldOrgId || oldOrgId === '') return;
            emit('update:modelValue', '');  // 清空 modelValue
        });

        watch(() => props.categoryId, (newCarId, oldCarId) => {
            if (newCarId === oldCarId || oldCarId === '') return;
            emit('update:modelValue', '');  // 清空 modelValue
        });

        return {
            loading,
            options,
            selectedMaterial,
            remoteMethod,
            handleChange,
        };
    },
});
</script>